import {reducerCases} from './constants'

export const initialState = {
  isShowCustomColumns: false,
  automationRulesMetadata: null,
}

const reducer = (state, action) => {
  switch (action.type) {
    case reducerCases.IS_SHOW_CUSTOM_COLUMNS:
      return {
        ...state,
        isShowCustomColumns: action.isShowCustomColumns,
      }
    case reducerCases.SET_AUTOMATION_RULES_METADATA:
      return {
        ...state,
        automationRulesMetadata: action.metadata,
      }
    default:
      return state
  }
}

export default reducer
